
import Overlay from '../../../components/Overlay.vue';
import { BarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';
import { defineComponent, reactive, toRefs } from 'vue';
import VChart from 'vue-echarts';

use([
  BarChart,
  CanvasRenderer,
  SVGRenderer,
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
]);

export default defineComponent({
  name: 'DashboardLeadTime',

  components: {
    Overlay,
    VChart,
  },

  props: {
    leadTimeTarget: {
      type: Number,
      default: 0,
    },
    monthLeadTime: {
      type: Number,
      default: 0,
    },
    ordersOffTarget: {
      type: Number,
      default: 0,
    },
    ordersWithinTarget: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    leadTimeTarget: {
      handler() {
        this.setOptionsChart();
      },
    },

    monthLeadTime: {
      handler() {
        this.setOptionsChart();
      },
    },

    ordersOffTarget: {
      handler() {
        this.setOptionsChart();
      },
    },

    ordersWithinTarget: {
      handler() {
        this.setOptionsChart();
      },
    },
  },

  methods: {
    setOptionsChart() {
      (this.$refs['chart'] as any).setOption({
        series: [
          {
            cursor: 'normal',
            name: 'Access From',
            type: 'pie',
            radius: ['62%', '72%'],
            emphasis: {
              series: 'none',
            },
            label: {
              show: true,
              position: 'center',
              formatter: () => {
                if (this.monthLeadTime > 1)
                  return `{text|Média Mês} \n {value|${this.monthLeadTime} Dias}`;
                return `{text|Média Mês} \n {value|${this.monthLeadTime} Dia}`;
              },
              rich: {
                text: {
                  align: 'center',
                  fontSize: 16,
                  padding: [0, 0, 20, 0],
                },
                value: {
                  align: 'center',
                  fontSize: 20,
                  fontWeight: 'bold',
                },
              },
            },
            data: [
              { value: this.ordersOffTarget, itemStyle: { color: '#E70024' } },
              {
                value: this.ordersWithinTarget,
                itemStyle: { color: '#219653' },
              },
            ],
          },
        ],
      });
    },
  },

  mounted() {
    this.setOptionsChart();
  },

  setup() {
    const state = reactive({
      options: {},
    });
    return { ...toRefs(state) };
  },
});
